/* eslint-disable css-modules/no-unused-class */
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
// jl-design-system
import { PrimaryButton } from 'jl-design-system/elements/button/Button';
import { Message } from 'jl-design-system/components/message/Message';
// components
import HiddenAlert from '../../widgets/accessibility/hiddenalert';
import GiftOptionsForm from './GiftOptionsForm';
import Container from '../container';
import { PaymentDeductionsList } from '../payment-deductions';
import { ANIMATION_TYPES } from '../../constants/giftOptionsConstants';
import errorMessageBodyLookup from '../../utils/error/errorMessageBodyLookup';
// styles
import styles from './apply-gift-options-forms.scss';

class ApplyGenericGiftOption extends PureComponent {
  static propTypes = {
    applyGiftPaymentFailed: PropTypes.bool,
    cardImage: PropTypes.string,
    doneButtonDataTest: PropTypes.string,
    doneButtonText: PropTypes.string,
    errorMessage: PropTypes.objectOf(PropTypes.any),
    formConfig: PropTypes.objectOf(PropTypes.any),
    formContainerClassName: PropTypes.string,
    formDataTest: PropTypes.string,
    formSubmitFailed: PropTypes.bool,
    hiddenAlertSubmittingText: PropTypes.string,
    instructionalText: PropTypes.string,
    instructionalTextDataTest: PropTypes.string,
    isLoading: PropTypes.bool,
    isZeroAmount: PropTypes.bool,
    // eslint-disable-next-line
    items: PropTypes.arrayOf(PropTypes.object), // only used in static method
    onDoneClick: PropTypes.func,
    onFormSubmit: PropTypes.func,
    onRemove: PropTypes.func,
    onUndo: PropTypes.func,
    outstandingBalance: PropTypes.string,
    removeGiftOptionLoading: PropTypes.bool,
    type: PropTypes.string,
  };

  static defaultProps = {
    applyGiftPaymentFailed: false,
    cardImage: '',
    doneButtonDataTest: '',
    doneButtonText: '',
    errorMessage: undefined,
    formConfig: undefined,
    formContainerClassName: '',
    formDataTest: '',
    formSubmitFailed: false,
    hiddenAlertSubmittingText: '',
    instructionalText: '',
    instructionalTextDataTest: '',
    isLoading: false,
    isZeroAmount: false,
    items: [],
    onDoneClick: window.defaultFunc,
    onFormSubmit: window.defaultFunc,
    onRemove: window.defaultFunc,
    onUndo: window.defaultFunc,
    outstandingBalance: '',
    removeGiftOptionLoading: false,
    type: '',
  };

  static getDerivedStateFromProps(props, state) {
    const { isLoading, items } = props;
    const { oldPropsItems } = state;

    if (isLoading) {
      return null;
    }

    const appliedNewItems = items.filter(x => !x.isRemoved);
    const appliedOldItems = oldPropsItems.filter(x => !x.isRemoved);

    let animation = null;

    if (oldPropsItems.length === 0 && appliedNewItems.length === 1) {
      animation = ANIMATION_TYPES.WHOLE_SECTION;
    } else if (appliedNewItems.length > appliedOldItems.length) {
      animation = ANIMATION_TYPES.NEW_ITEM;
    }

    const defaultState = {
      oldPropsItems: items,
      list: items.reverse(),
    };

    if (!animation) {
      return defaultState;
    }

    return {
      ...defaultState,
      animation,
    };
  }

  constructor() {
    super();

    this.state = {
      animation: undefined,
      list: [],
      oldPropsItems: [],
    };
  }

  render() {
    const {
      applyGiftPaymentFailed,
      cardImage,
      doneButtonDataTest,
      doneButtonText,
      errorMessage,
      formConfig,
      formContainerClassName,
      formDataTest,
      formSubmitFailed,
      hiddenAlertSubmittingText,
      instructionalText,
      instructionalTextDataTest,
      isLoading,
      isZeroAmount,
      onDoneClick,
      onFormSubmit,
      onRemove,
      onUndo,
      outstandingBalance,
      removeGiftOptionLoading,
      type,
    } = this.props;

    const { animation, list } = this.state;

    return (
      <div className={styles.applyGiftContainer}>
        {
          isLoading &&
          <HiddenAlert text={hiddenAlertSubmittingText} />
        }

        {errorMessage && (
          <Container marginBottom="2">
            <Message
              body={errorMessageBodyLookup({
                body: errorMessage.body,
                bodyLookup: errorMessage.bodyLookup,
              })}
              title={errorMessage.message}
              type="error"
            />
          </Container>
        )}

        <p
          className={styles.introCopy}
          data-testid={instructionalTextDataTest}
        >
          {instructionalText}
        </p>

        <div className={styles.content}>
          <div className={styles.imageWrapper}>
            <img alt={instructionalText} className={styles.image} src={cardImage} />
          </div>

          <div className={styles.formContainer}>
            <GiftOptionsForm
              config={formConfig}
              dataTest={formDataTest}
              disabled={isZeroAmount || removeGiftOptionLoading || isLoading}
              formContainerClassName={formContainerClassName}
              formSubmitFailed={formSubmitFailed}
              hideProgressImmediately={!!errorMessage}
              isLoading={isLoading}
              onDoneClick={onDoneClick}
              onFormSubmit={onFormSubmit}
            />

            <PaymentDeductionsList
              animation={animation}
              applyGiftPaymentFailed={applyGiftPaymentFailed}
              balance={outstandingBalance}
              isRemovable
              list={list}
              onRemove={onRemove}
              onUndo={onUndo}
              showUndo
              type={type}
            />

            <PrimaryButton
              className={styles.doneButton}
              data-testid={doneButtonDataTest}
              disabled={isLoading || removeGiftOptionLoading}
              onClick={onDoneClick}
            >
              {doneButtonText}
            </PrimaryButton>
          </div>
        </div>
      </div>
    );
  }
}

export default ApplyGenericGiftOption;
